/** @jsx jsx */
import React from 'react';

import { Colors, Spacing } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

type BoxProps = {
  // Note: I would like to make padding: keyof typeof Spacing but this messes with flowgen
  /** Standard padding to apply. */
  padding?: string;
  /** The children of the component. */
  children: React.ReactNode;
};

const getBoxCss = (props: BoxProps) =>
  css({
    borderRadius: '3px',
    border: `1px solid ${Colors.adamantium}`,
    padding: `${Spacing[props.padding as keyof typeof Spacing]}px`,
    backgroundColor: Colors.white,
  });

/**
 * Renders a box.
 */
const Box = (props: BoxProps) => (
  <article css={getBoxCss(props)}>{props.children}</article>
);

Box.defaultProps = {
  padding: 'medium',
};
export default Box;
